<template>
  <cs-modal v-model="shown">
    <div slot="content-wrapper" class="capusta-info">
      <div class="capusta-info-close" @click="handleClose"></div>
      <div ref="scrollContent" class="capusta-info-content">
        <h4 class="capusta-info-content-title">
          {{ $t('how.it.works.title') }}
        </h4>
        <div class="capusta-info-content-text" v-html="$t('how.it.works.message')"></div>
        <button class="capusta-info-done" @click="handleClose">
          {{ $t('common.ok') }}
        </button>
      </div>
    </div>
  </cs-modal>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default {
  name: 'BillInformationModal',
  props: {
    value: Boolean,
  },
  data() {
    return {
      shown: false,
    };
  },
  watch: {
    value(val) {
      this.shown = val;
    },
    shown(val) {
      this.$emit('input', val);

      if (val) {
        disableBodyScroll(this.$refs.scrollContent);
      } else {
        enableBodyScroll(this.$refs.scrollContent);
      }
    },
  },
  methods: {
    handleClose() {
      this.shown = false;
    },
  },
};
</script>

<style lang="sass" scoped>
  .capusta-info
    width: 100%
    max-width: 35.71rem
    max-height: 80vh
    background-color: $pure-white
    padding: 2.85rem 0
    position: relative
    overflow: hidden
    display: flex
    border-radius: 0.48rem
    box-shadow: 0 0 2.84rem rgba(248, 248, 248, 0.6)

    @media (max-width: 480px)
      width: calc(100% - (.64rem * 2))
      padding: 2rem 0
    @media (max-width: 360px)
      padding: 1.6rem 0

  .capusta-info-close
    width: 17px
    height: 17px
    padding: 1.6rem
    position: absolute
    right: 1rem
    top: 1rem
    z-index: 2
    background-color: transparent
    +flex-center()
    cursor: pointer
    transition: .2s ease

    @media (max-width: 480px)
      top: 0
      right: 0
    @media (max-width: 360px)
      padding: 1.4rem

    &::before,
    &::after
      content: ''
      position: absolute
      width: 17px
      height: 2px
      background-color: #000

    &::before
      transform: rotate(45deg)
    &::after
      transform: rotate(-45deg)
    &:hover
      transform: scale(1.1)

  .capusta-info-content
    overflow: auto
    padding: 0 2.85rem
    color: #000
    h4
      font-size: 1.4rem
      font-weight: 600
    p
      font-size: 1rem
      font-weight: 500
      padding-top: 1.6rem
      &:last-of-type
        padding-bottom: 1.6rem

    @media (max-width: 480px)
      padding: 0 2rem
    @media (max-width: 360px)
      padding: 0 1.6rem

  .capusta-info-content-title
    position: sticky
    top: 0
    padding-bottom: .5rem
    background: #fff

    & + p
      padding-top: 1.1rem

  .capusta-info-content-text
    padding-bottom: 1.6rem

    &::v-deep p
      font-size: 1rem
      font-weight: 500
      padding-top: 1.6rem

  .capusta-info-done
    font-size: 1.12rem
    font-weight: 600
    width: 100%
    margin: 0 auto
    display: block
    padding: 0.8rem
    color: $soft-white
    border-radius: 2.48rem
    background-color: #7CB342

    @media (min-width: 767px)
      max-width: 12.85rem

    &:hover
      color: $pure-white
    &:disabled,
    &.disabled
      cursor: not-allowed
      background-color: #4e5a5f
    &.loading
      font-size: 0
      cursor: progress
      &::after
        content: ". . ."
        font-size: 1.12rem
</style>
